export * from "-!../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./DeviceActions.vue?vue&type=template&id=da9d7742"


//////////////////
// WEBPACK FOOTER
// ./src/components/Device/DeviceActions.vue?vue&type=template&id=da9d7742
// module id = 2065
// module chunks = 5